import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class EnGbDateAdapter extends NativeDateAdapter {
  // This constructor ensures locale is passed to parent
  constructor() {
    super('en-GB');
  }

  /**
   * OVERRIDE: Parse date string into Date object
   * This is the key method that handles '15/12/2029' format
   */
  override parse(value: any): Date | null {
    // If value is empty/null, return null
    if (value == null || value === '') {
      return null;
    }

    if (typeof value === 'string') {
      const parsedDate = this.parseEnGbFormat(value);
      if (parsedDate) {
        return parsedDate;
      }

      // Fallback to ISO format or native parsing
      const isoDate = Date.parse(value);
      if (!isNaN(isoDate)) {
        return new Date(isoDate);
      }
    }

    // For other types (Date objects, numbers), use parent's parse
    return super.parse(value);
  }

  private parseEnGbFormat(value: string): Date | null {
    // Match DD/MM/YYYY / DD-MM-YYYY / DD MM YYYY pattern
    const enGbRegex = /^(\d{1,2})[\/\-\.\s](\d{1,2})[\/\-\.\s](\d{4})$/;
    const match = value.match(enGbRegex);

    if (!match) {
      return null;
    }

    // Extract day, month, year from regex groups
    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const year = parseInt(match[3], 10);

    // Validate: month must be 1-12, day must be valid for month
    if (month < 1 || month > 12) {
      return null;
    }

    // Create date (months are 0-based in JavaScript!)
    const date = new Date(year, month - 1, day);

    // Verify the date is valid (handles Feb 30, etc.)
    const isValid = date.getFullYear() === year &&
                    date.getMonth() === month - 1 &&
                    date.getDate() === day;

    return isValid ? date : null;
  }
}